import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root container #root not found')

// `ErrorBoundary` sits inside `StrictMode` and wraps the whole app: React
// unmounts the entire tree when a render throws and nothing catches it, which
// would leave the user with a blank document. The boundary turns that into a
// short message instead.
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
